import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as TowersAPI from './towerAPI';

export const listTower = createAsyncThunk('towers/list', async ({ projectId, page, username, tag }, { rejectWithValue }) => {
    try {
        const resposne = await TowersAPI.listTower({ projectId, page, username, tag });
        return resposne.data;
    } catch (error) {
        return rejectWithValue(error.resposne.data);
    }
});

const initialState = {
    towers: null,
    error: null,
    lastPage: 1,
};

const towersSlice = createSlice({
    name: 'towers',
    initialState,
    reducers: {
        unloadTowerList: state => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(listTower.fulfilled, (state, { payload }) => {
                state.towers = payload;
                state.error = null;
            })
            .addCase(listTower.rejected, (state, { payload }) => {
                state.towers = null;
                state.error = payload;
            })
    },
});

export const { unloadTowerList } = towersSlice.actions;
export default towersSlice.reducer;